/** Empty object schema — fully editable in the interactive editor. */
export const INTERACTIVE_EDITOR_DEFAULT_SCHEMA = {
  type: "object",
  properties: {},
  required: [],
  additionalProperties: false,
} as const;
